// test1843
(1843 && 0);
